import React from 'react';
import { useHistory } from 'react-router-dom';

import { Button, Flex, H3, LssProp } from '@lucidhq/lucidium';
import {
  CustomServicesIcon,
  IMCampaignSetupIcon
} from '@lucidhq/lucidium/icons';

import { LandingCardBtn } from '~/impact-measurement/components';
import { BasePage, PageContentWrapper } from '~/impact-measurement/components';
import { CampaignTypes } from '~/types';
import { getCampaignManagerRoute } from '~/utils/campaignManager';
import { t } from '~/utils/i18n';

import { BackToStudiesDialog } from '../CampaignManager/BackToStudiesDialog';

const cardsContainerLss: LssProp = {
  height: 'auto',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  tablet: {
    flexDirection: 'row',
    alignItems: 'stretch'
  }
};

export const CampaignManagerLanding = () => {
  const history = useHistory();

  return (
    <BasePage isFluid hasFooter={false}>
      <Flex lss={{ flexDirection: 'row', m: 'sm' }}>
        <BackToStudiesDialog>
          {({ onToggle }) => (
            <Button
              id="back-to-studies-trigger"
              onClick={onToggle}
              palette="secondary"
              emphasis="medium"
              type="button"
              lss={{ maxHeight: '2.5rem' }}
            >
              {t('backToStudiesDialog.triggerLabel')}
            </Button>
          )}
        </BackToStudiesDialog>
      </Flex>
      <PageContentWrapper>
        <Flex lss={{ justifyContent: 'center', mb: 'xxl' }}>
          <H3>{t('campaignManagerLanding.title')}</H3>
        </Flex>
        <Flex lss={cardsContainerLss}>
          <LandingCardBtn
            name={t('campaignManagerLanding.softwarev2.title')}
            icon={IMCampaignSetupIcon}
            description={t('campaignManagerLanding.softwarev2.description')}
            handleClick={() =>
              history.push(getCampaignManagerRoute(CampaignTypes.SOFTWARE))
            }
            cardContentLss={{ py: 'xxxl' }}
          />
          <LandingCardBtn
            name={t('campaignManagerLanding.servicev2.title')}
            icon={CustomServicesIcon}
            description={t('campaignManagerLanding.servicev2.description')}
            handleClick={() =>
              history.push(getCampaignManagerRoute(CampaignTypes.SERVICE))
            }
            cardContentLss={{ py: 'xxxl' }}
          />
        </Flex>

        <Flex lss={cardsContainerLss}>
          <LandingCardBtn
            name={t('campaignManagerLanding.softwarev1.title')}
            description={t('campaignManagerLanding.softwarev1.description')}
            handleClick={() => history.push('/admin/campaign/new?type=im')}
            cardContentLss={{ py: 'xxl' }}
          />
          <LandingCardBtn
            name={t('campaignManagerLanding.servicev1.title')}
            description={t('campaignManagerLanding.servicev1.description')}
            handleClick={() => history.push('/admin/campaign/new?type=custom')}
            cardContentLss={{ py: 'xxl' }}
          />
        </Flex>
      </PageContentWrapper>
    </BasePage>
  );
};
